export const EVENT_NAMES = {
  // アクション系
  SIGN_UP: "sign_up",
  LOGIN: "login",
  EDIT_PROFILE: "edit_profile",
  UPLOAD_PROFILE_AVATAR: "upload_profile_avatar",
  PURCHASE: "purchase",
  SEND_GOOD: "SEND_GOOD",
  ADD_FAVORITE: "ADD_FAVORITE",
  COMPLETE_SEND_MESSAGE: "COMPLETE_SEND_MESSAGE",
  COMPLETE_SEND_ONE_TAP_MESSAGE_FROM_BOARD:
    "COMPLETE_SEND_ONE_TAP_MESSAGE_FROM_BOARD",
  COMPLETE_SEND_FREE_MESSAGE_FROM_BOARD:
    "COMPLETE_SEND_FREE_MESSAGE_FROM_BOARD",
  COMPLETE_SEND_GIFT: "COMPLETE_SEND_GIFT",
  COMPLETE_SEND_STAMP: "COMPLETE_SEND_STAMP",
  COMPLETE_BUY_IMAGE: "COMPLETE_BUY_IMAGE",
  COMPLETE_BUY_VIDEO: "COMPLETE_BUY_VIDEO",
  COMPLETE_BUY_AUDIO: "COMPLETE_BUY_AUDIO",
  START_VIDEO_CALL: "START_VIDEO_CALL",
  START_VOICE_CALL: "START_VOICE_CALL",
  START_VIDEO_CHAT: "START_VIDEO_CHAT",
  CALL_STARTED: "CALL_STARTED",
  CALL_ENDED: "CALL_ENDED",
  WATCH_VIDEO_CHAT_AS_FIRST_VIEWER: "WATCH_VIDEO_CHAT_AS_FIRST_VIEWER",
  WATCH_VIDEO_CHAT_AS_VIEWER: "WATCH_VIDEO_CHAT_AS_VIEWER",
  // Lovenseバッジ（評価バッジ「Lovense反応◎」）有無別の入室内訳集計用（Repro は props 転送不可のためサフィックスで分ける）
  WATCH_VIDEO_CHAT_AS_FIRST_VIEWER_LOVENSE_BADGE:
    "WATCH_VIDEO_CHAT_AS_FIRST_VIEWER_LOVENSE_BADGE",
  WATCH_VIDEO_CHAT_AS_FIRST_VIEWER_NO_LOVENSE_BADGE:
    "WATCH_VIDEO_CHAT_AS_FIRST_VIEWER_NO_LOVENSE_BADGE",
  WATCH_VIDEO_CHAT_AS_VIEWER_LOVENSE_BADGE:
    "WATCH_VIDEO_CHAT_AS_VIEWER_LOVENSE_BADGE",
  WATCH_VIDEO_CHAT_AS_VIEWER_NO_LOVENSE_BADGE:
    "WATCH_VIDEO_CHAT_AS_VIEWER_NO_LOVENSE_BADGE",
  INCOMING_VOICE_CALL: "INCOMING_VOICE_CALL",
  INCOMING_VIDEO_CALL: "INCOMING_VIDEO_CALL",
  OUTGOING_VOICE_CALL: "OUTGOING_VOICE_CALL",
  OUTGOING_VIDEO_CALL: "OUTGOING_VIDEO_CALL",
  SEND_VOICE_CALL_REQUEST: "SEND_VOICE_CALL_REQUEST",
  SEND_VIDEO_CALL_REQUEST: "SEND_VIDEO_CALL_REQUEST",
  SEND_IMAGE_FILE_REQUEST: "SEND_IMAGE_FILE_REQUEST",
  SEND_VIDEO_FILE_REQUEST: "SEND_VIDEO_FILE_REQUEST",
  SEND_MESSAGE_IN_VIDEO_CHAT: "SEND_MESSAGE_IN_VIDEO_CHAT",
  SEND_LOVENSE_IN_VIDEO_CHAT: "SEND_LOVENSE_IN_VIDEO_CHAT",
  SEND_LOVENSE_IN_VIDEO_CALL: "SEND_LOVENSE_IN_VIDEO_CALL",
  SEND_LOVENSE_FROM_QUICK_MENU: "SEND_LOVENSE_FROM_QUICK_MENU",
  SEND_FREE_LOVENSE: "SEND_FREE_LOVENSE",
  TAP_FREE_LOVENSE_BUTTON: "TAP_FREE_LOVENSE_BUTTON",
  SEND_GIFT_IN_VIDEO_CHAT: "SEND_GIFT_IN_VIDEO_CHAT",
  SEND_GIFT_IN_VIDEO_CALL: "SEND_GIFT_IN_VIDEO_CALL",
  SHOW_POINT_SHORTAGE_MODAL: "SHOW_POINT_SHORTAGE_MODAL",
  // 通話中・ライブ視聴中にまず表示する控えめな通知バナー（タップでSHOW_POINT_SHORTAGE_MODALのシートに遷移）
  SHOW_POINT_SHORTAGE_NOTICE: "SHOW_POINT_SHORTAGE_NOTICE",
  // IAP 課金モーダル別の購入完了内訳（Repro は props 転送不可のためイベント名で分ける）
  PURCHASE_FROM_POINT_SHORTAGE_MODAL: "PURCHASE_FROM_POINT_SHORTAGE_MODAL",
  PURCHASE_FROM_LIVE_CHARGE_MODAL: "PURCHASE_FROM_LIVE_CHARGE_MODAL",
  PURCHASE_FROM_CALL_CHARGE_MODAL: "PURCHASE_FROM_CALL_CHARGE_MODAL",
  USE_SIGNUP_POINT: "use_signup_point",
  START_DEMO_CALL: "START_DEMO_CALL",
  CONSUME_POINT_AFTER_DEMO_CALL: "CONSUME_POINT_AFTER_DEMO_CALL",
  SHOW_DEMO_CALL_BANNER: "SHOW_DEMO_CALL_BANNER",
  DECLINE_DEMO_CALL: "DECLINE_DEMO_CALL",
  // 高評価ユーザー紹介オンボーディング（さがす画面→プロフィール→通話リクエスト）の進捗計測
  START_HIGH_REVIEW_ONBOARDING: "START_HIGH_REVIEW_ONBOARDING",
  REACH_HIGH_REVIEW_ONBOARDING_PROFILE: "REACH_HIGH_REVIEW_ONBOARDING_PROFILE",
  SKIP_HIGH_REVIEW_ONBOARDING: "SKIP_HIGH_REVIEW_ONBOARDING",
  COMPLETE_HIGH_REVIEW_ONBOARDING: "COMPLETE_HIGH_REVIEW_ONBOARDING",
  // オンボーディング経由で実際に通話まで到達したかのアトリビューションマーカー（Repro専用。CONSUME_POINT_AFTER_DEMO_CALL と同じ扱い）
  COMPLETE_HIGH_REVIEW_ONBOARDING_TO_CALL:
    "COMPLETE_HIGH_REVIEW_ONBOARDING_TO_CALL",
  // チャットの pt 不足を先回りで知らせるモーダル（送信を待たずに購入導線を届ける）
  SHOW_CHAT_POINT_SHORTAGE_PROMPT: "SHOW_CHAT_POINT_SHORTAGE_PROMPT",
  TAP_CHAT_POINT_SHORTAGE_PROMPT_CHARGE:
    "TAP_CHAT_POINT_SHORTAGE_PROMPT_CHARGE",
  // Adjust刷新（Carina）で追加した計測。値は Adjust ダッシュボード登録名に合わせる
  VIDEOCALL_END: "videocall_end",
  VIDEOCHAT_END: "videochat_end",
  SEND_VIDEO_COMPLETE_LOVENSE: "send_video_complete_lovense",
  SEND_VIDEOCHAT_COMPLETE_LOVENSE: "send_videochat_complete_lovense",
  REMOVE_FAVORITE: "remove_favorite",
  ADD_ABOUT_ME: "add_about_me",
  ADD_AGE: "add_age",
  GET_DAILY_BONUS: "get_dailybonus",
  POST_REVIEW: "post_review",
  TAP_SEARCH: "tap_search",
  SEARCH_NAME: "search_name",
  SEARCH_BODY: "search_body",
  SEARCH_AGE: "search_age",
  SEARCH_LOCATION: "search_location",
  SEARCH_VIDEOCALL: "search_videocall",
  OPEN_FLEAMARKET_ITEM: "open_fleamarket_item",
  VIEW_FLEAMARKET_ITEM_FROM_PROFILE: "view_fleamarket_item_from_profile",
  OPEN_PROFILE_FROM_FLEAMARKET_ITEM: "open_profile_from_fleamarket_item",
  FAVORITE_FLEAMARKET_ITEM: "favorite_fleamarket_item",
  PURCHASED_FLEAMARKET_ITEM: "purchased_fleamarket_item",
  // ページ表示系
  OPEN_GIRLS_ALL: "OPEN_GIRLS_ALL",
  OPEN_LIVE_LIST: "OPEN_LIVE_LIST",
  OPEN_CONVERSATION_ALL: "OPEN_CONVERSATION_ALL",
  OPEN_BOARD: "OPEN_BOARD",
  OPEN_GALLERY: "OPEN_GALLERY",
  OPEN_MYPAGE: "OPEN_MYPAGE",
  OPEN_FOOTPRINT_LIST: "OPEN_FOOTPRINT_LIST",
  OPEN_BOOKMARK_LIST: "OPEN_BOOKMARK_LIST",
  OPEN_LIKE_LIST: "OPEN_LIKE_LIST",
  OPEN_FLEA_MARKET: "OPEN_FLEA_MARKET",
  OPEN_PURCHASE: "OPEN_PURCHASE",
  OPEN_SEARCH: "OPEN_SEARCH",
  // さがす画面の表示。Adjust トークン未割り当てのため Repro のみに送られる
  OPEN_DISCOVER: "OPEN_DISCOVER",
  OPEN_DAILY_BONUS: "OPEN_DAILY_BONUS",
  OPEN_PROFILE_DETAIL: "OPEN_PROFILE_DETAIL",
  OPEN_LIVE_PROFILE_FROM_DISCOVER: "OPEN_LIVE_PROFILE_FROM_DISCOVER",
  // 通知許諾系
  SHOW_NOTIFICATION_PERMISSION: "Show notification permission",
  APPROVE_NOTIFICATION: "Approve notification",
} as const;

export type EventName = (typeof EVENT_NAMES)[keyof typeof EVENT_NAMES];
